<template>
  <div id="app" :class="{ home: $route.path === '/' }">
    <nav class="offcanvasmenu">
      <div class="bootstrap-wrapper">
        <div class="container custom">
          <div class="row">
            <div class="column col-md-5">
              <router-link to="/" class="logo">
                <img src="../src/assets/praxis-lambrette-logo.svg" alt="Logo" />
              </router-link>
            </div>
            <div class="column col-md-7">
              T: 0351 89510970
              <a href="mailto:info@praxis-lambrette.de"
                >info@praxis-lambrette.de</a
              >
            </div>
          </div>
        </div>
      </div>
      <Button></Button>
    </nav>

    <Navbar>
      <ul class="navbar-panel-nav">
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/">Home</router-link>
        </li>
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/gutachten-im-familienrecht"
            >Gutachten im Familienrecht</router-link
          >
        </li>
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/supervision-und-seminare"
            >Supervision und Seminare</router-link
          >
        </li>
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/gutachten-im-waffenrecht"
            >Gutachten im Waffenrecht</router-link
          >
        </li>
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/impressum" class="meta-nav">Impressum</router-link>
        </li>
        <li @click="closeNavbarPanel" v-if="isPanelOpen">
          <router-link to="/datenschutz" class="meta-nav"
            >Datenschutz</router-link
          >
        </li>
      </ul>
    </Navbar>

    <vue-page-transition name="fade">
      <router-view />
    </vue-page-transition>

    <Footer></Footer>
    <cookie-law
      theme="dark-red"
      buttonText="verstanden"
      position="bottom"
      transitionName="fade"
    >
      <div slot="message">
        Um die Webseite optimal gestalten und fortlaufend verbessern zu können,
        verwendet wir Cookies. Durch die weitere Nutzung der Webseite stimmen
        Sie der Verwendung von Cookies zu.
        <router-link to="/datenschutz"
          >Unsere Datenschutzbestimmungen</router-link
        >
      </div>
    </cookie-law>
  </div>
</template>

<script>
import Button from "./components/offcanvasmenu/Button.vue";
import Navbar from "./components/offcanvasmenu/Navbar.vue";
import Footer from "./components/Footer.vue";
import { store, mutations } from "@/store.js";
import CookieLaw from "vue-cookie-law";

export default {
  name: "app",
  components: {
    Button,
    Navbar,
    Footer,
    CookieLaw
  },
  methods: {
    closeNavbarPanel: mutations.toggleNav
  },
  computed: {
    isPanelOpen() {
      return store.isNavOpen;
    }
  }
};
</script>

<style lang="scss">
.offcanvasmenu {
  width: 100%;
  height: 100px;
  padding: 1.25rem;

  .logo img {
    width: 271px;
    height: 56px;
  }
}

ul.navbar-panel-nav {
  font-family: "open_sansregular", sans-serif;
  line-height: normal;
  text-align: center;

  li {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }

  a {
    color: $brand-color;
    text-decoration: none;
    text-transform: uppercase;
    display: block;

    &.meta-nav {
      text-transform: initial;
    }

    &.router-link-exact-active {
      color: $font-color;
    }
  }
}

.custom {
  .column {
    height: 56px;
  }
  .column:last-child {
    display: none;
    justify-content: flex-end;
    align-items: center;
    text-align: right;

    a {
      margin-left: 20px;
    }
  }
}

@media screen and (max-width: 767px) {
  .custom {
    max-width: 100% !important;
    .column {
      padding: 0 !important;
    }
  }
}

@media screen and (min-width: 768px) {
  .home .offcanvasmenu .logo {
    display: none;
  }

  ul.navbar-panel-nav {
    text-align: left;

    a {
      width: 50%;
    }
  }

  .custom .column:last-child {
    display: flex;
  }
}

.Cookie--dark-red {
  font-family: "open_sanslight", sans-serif;
  font-size: 1rem;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 1.25em;

  .Cookie__button {
    font-size: 1rem;
    background-color: $brand-color;
    padding: 0.75rem 3rem;
    color: $white;
    border: 0;
    border-radius: 0;

    &:hover {
      background-color: darken($brand-color, 5%);
    }
  }

  .Cookie__content a {
    color: $white;
  }
}
</style>
